export var TREND_STATUS;
(function (TREND_STATUS) {
  TREND_STATUS[TREND_STATUS["PRICE"] = 0] = "PRICE";
  TREND_STATUS[TREND_STATUS["REQUEST"] = 1] = "REQUEST";
  TREND_STATUS[TREND_STATUS["TRANSACTION"] = 2] = "TRANSACTION";
})(TREND_STATUS || (TREND_STATUS = {}));